//对任务类型进行修改 img
import icon_unassignO from "@/assets/diapatch/task/unassignO.png";
import icon_purpleO from "@/assets/diapatch/task/pin(5).svg";
import icon_buleO from "@/assets/diapatch/task/bule.png";
import icon_greenO from "@/assets/diapatch/nomal/icon_greenO.png";
import icon_redO from "@/assets/diapatch/nomal/icon_redO.png";
import icon_unassignP from "@/assets/diapatch/task/unassignP.png";
import icon_purpleP from "@/assets/diapatch/task/pin(1).svg";
import icon_greenP from "@/assets/diapatch/task/pin(4).svg";
import icon_redP from "@/assets/diapatch/task/pin(3).svg";
import icon_buleP from "@/assets/diapatch/task/pin(2).svg";
export default {
  changetaskImg(data) {
    let type = ''
    let status = 0
    if (data.type === 'all') {
      data.list.forEach(i => {
        type = i.is_pickup
        status = i.status
      })
    } else {
      type = data.is_pickup
      status = data.status
    }
    if (type == 1) {
      switch (status) {
        case 0:
          return icon_unassignO;
        case 1:
          return icon_purpleO;
        case 2:
          return icon_buleO;
        case 3:
          return icon_greenO;
        case 4:
          return icon_redO;
        default: icon_purpleO
      }
    } else if (type == 0) {
      switch (status) {
        case 0:
          return icon_unassignP;
        case 1:
          return icon_purpleP;
        case 3:
          return icon_greenP;
        case 4:
          return icon_redP;
        case 2:
          return icon_buleP;
      }
    } else {
      return icon_unassignO
    }
  },
}
